import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { NgForm } from '@angular/forms';
import { EmailService } from '../../../services/email.service';
import { Attachment, Email, EmailAttachment, EmailData } from '../../../types/email-data.types';
import { AuthenticationService } from '../../../services/authentication.service';
import { ConstantsService } from '../../../services/constants.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/interval';
import { ApiClientService } from '../../../services/api-client.service';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';
import * as lodash from 'lodash';
import {UrlService} from '../../../services/url.service';
import { AuthTokenService } from '../../../services/auth-token.service';
import { INpmiPublicNotice } from '../../../types/api-response/npmi-public-notice';
import {ICorporation} from '../../../types/api-response/corporation';
import {catchError} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';

declare const swal: any;
declare const toastr: any;
declare const $: any;

@Component({
    templateUrl: './compose-email.component.html',
    styleUrls: ['./compose-email.component.scss']
})
export class ComposeEmailComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;
    data: Email = new Email();
    disabledSubmit = false;
    disabledFileInput = false;
    recipientFilterState = [];
    from = 'notice@maxcondoclub.ca';
    senderName = 'MaxCondoClub';
    fromCopy = '';
    senderNameCopy = '';
    isFromEditMode = false;
    placeholders = [ // TODO: move to file and use exported Enum type for all placeholders
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[INVITATION_LINK]]',
        '[[MY_SIGNATURE]]',
        '[[DATA_CONFIRMATION_LINK]]',
        '[[MCC_INVITATION_LINK]]',
        '[[COMMON_ELEMENTS_FEE]]'
    ];

    isSpinnerShow: boolean = false;
    emailMessageType: 'default'|'notice'|'template' = 'default';
    showUsersSpinner = false;
    users = [];
    replyToRecipientSearch = '';
    timer: Subscription;
    autoSaved: boolean = false;
    initialState: Email;
    dropdown: any;
    newMessage: boolean;
    closeAfterSave: boolean;
    copy: boolean;
    emailSettings = [];

    /**
     * Summernote object
     * docs: https://summernote.org/deep-dive/#basic-api
     */
    private summernote;

    /**
     * Notice details storage
     */
    private prevNoticeContent;
    private prevNoticeTitle;

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    constructor(
        public api: ApiClientService,
        public es: EmailService,
        public urlService: UrlService,
        public authService: AuthenticationService,
        private http: Http,
        private authTokenService: AuthTokenService
    ) { }

    ngOnInit() {
        this.es.getBuildings();
        this.es.getGroups();
        this.es.initFilter();
        this.es.getCorporations();
        this.initData();

        const userData = JSON.parse(localStorage.getItem('userData'));
        if(userData.company)
            this.getCompanySettings(userData.company.id);

        this.getCorporationSettings();

        if (this.es.emailInComposePage) {
            this.copy = !['draft', 'scheduled'].includes(this.es.emailInComposePage.status);
        }

        this.initSummernote();

        if (!this.data.id) {
            this.newMessage = true;
        }
        this.urlService.modalOpened.emit();
    }

    ngOnDestroy() {
        this.es.emailInComposePage = null;
        this.recipientFilterState = [];
        if(this.timer)
            this.timer.unsubscribe();
    }

    initData() {
        if (this.es.emailInComposePage) {
            this.data = this.es.emailInComposePage;
            // this.from = this.data.sender;
            // this.senderName = this.data.senderName;
            try {
                this.recipientFilterState = JSON.parse(this.es.emailInComposePage.filters);
                this.es.filterRecipients.residents = JSON.parse(this.es.emailInComposePage.recipientsFilter);
                this.es.filterRecipients.updateCheckboxState();
            } catch (e) {
                console.warn(e);
            }
        }
        this.getUsers();
    }

    initSummernote() {
        document.body.classList.add('body-upload-file-email');

        this.summernote = $('#summernote');
        this.summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => this.data.message = contents,
                onImageUpload: files => this.es.uploadFile(files, this.summernote),
                onMediaDelete: target => this.es.deleteFile(target, this.summernote)
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr', 'picture']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                this.summernote.summernote('editor.restoreRange');
                this.summernote.summernote('editor.focus');
                this.summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.data.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                this.summernote.summernote('editor.saveRange');
            }
        });
    }

    validateFields() {
        if (this.isFromEditMode) {
            toastr.warning('Please enter the valid email address and confirm it before sending.');
            this.disabledSubmit = false;
            return false;
        }
        if (!this.getResidentData().length) {
            $('.recipients-field').addClass('ng-invalid');
            toastr.warning('You must select recipients.');
            this.disabledSubmit = false;
            return false;
        }

        if (!this.data.subject) {
            toastr.warning('Email Subject must be entered.');
            this.disabledSubmit = false;
            return false;
        }

        if (!this.data.message) {
            toastr.warning('Message should not be blank.');
            this.disabledSubmit = false;
            return false;
        }

        if (!this.data.replyTo && !this.data.replyToName && this.replyToRecipientSearch &&
            !this.replyToRecipientSearch.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
            toastr.warning('Field "Reply To" should contain the email or be empty.');
            this.disabledSubmit = false;
            return false;
        }

        return true;
    }

    onSubmit(form: NgForm, saveAsDraft?: boolean, autoSave?: boolean) {
        const numberOfRecipients = this.getResidentData().length;
        if(!autoSave && !saveAsDraft && numberOfRecipients > 1) {
            swal(ConstantsService.getSwalConfig('Confirmation', `You are going to send email to ${numberOfRecipients} recipients.\n Do you want to continue?`),
                () => this.sendEmail(form, saveAsDraft, autoSave)
            );
        } else
            this.sendEmail(form, saveAsDraft, autoSave);
    }

    sendEmail(form: NgForm, saveAsDraft?: boolean, autoSave?: boolean) {
        if(form.value.saveAsDefaultInvitation) {
            if(this.es.corporations.length === 1) {
                const data = {
                    inviteTemplate: this.data.message
                };
                const url = `/v1/corporation_number/${this.es.corporations[0].id}`;
                this.api.patch('domainBD', url, data).subscribe(
                    () => {
                        toastr.success('Invitation message has been updated successfully.');
                        $('#saveAsDefaultInvitation')[0].checked = false;
                    },
                    error => this.api.errorHandler(error, 'Failed to update Invitation message!')
                );
            } else
                this.es.isChooseCorporationModalShow = true;
        }

        if (!autoSave) {
            this.autoSaved = false;
        }
        let doNotSubmitForm = false;
        const recipients     = this.getResidentData();
        const buildingsIdArr = this.es.filterRecipients.getBuildingsContainCheckedUser();

       // if (!form.controls['from'].valid) { toastr.warning('Field "From" not valid.'); return; }
        if (!recipients.length) {
            $('.recipients-field').addClass('ng-invalid');
            toastr.warning('You must select recipients.');
            doNotSubmitForm = true;
        }
        if (this.isFromEditMode) {
            toastr.warning('Please enter the valid email address and confirm it before sending.');
            doNotSubmitForm = true;
        }

        if (!form.value.subject) {
            toastr.warning('Email Subject must be entered.');
            doNotSubmitForm = true;
        }

        if (!this.data.message) {
            toastr.warning('Message should not be blank.');
            doNotSubmitForm = true;
        }

        if (!this.data.replyTo && !this.data.replyToName && this.replyToRecipientSearch &&
            !this.replyToRecipientSearch.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
            toastr.warning('Field "Reply To" should contain the email or be empty.');

            return;
        }

        if (doNotSubmitForm) {
            return;
        }

        // Compose email
        const emailData: EmailData = {
            sender:           this.from,
            senderName:       this.senderName,
            subject:          form.value.subject,
            replyTo:          this.data.replyTo ? this.data.replyTo : this.replyToRecipientSearch,
            replyToName:      this.data.replyToName ? this.data.replyToName : this.replyToRecipientSearch,
            message:          this.data.message,
            sendMeCopy:       form.value.sendMeCopy,
            filters:          JSON.stringify(this.recipientFilterState),
            recipients:       recipients,
            recipientsFilter: JSON.stringify(this.es.filterRecipients.residents),
            attachments:      this.getAttachmentsData(),
            pmEmail:          this.authService.user.email,
            pmMobilePhone:    this.authService.user.phone,
            pmName:           this.authService.user.fullName,
            buildingId:       buildingsIdArr,
            buildingName:     this.es.buildings[0].name,
            buildingAddress:  this.es.buildings[0].address,
            scheduleDate:     this.data.status == 'scheduled' ? this.data.scheduleDate : undefined,
            status:           this.data.status != 'scheduled' ? (!saveAsDraft ? 'in_progress' :  'draft') : 'scheduled'
        };

        this.disabledSubmit = true;
        this.isSpinnerShow = true;
        const url = !this.data.id ? '/api/v1/mailings' : `/api/v1/mailings/${this.data.id}`;
        this.es.api[!this.data.id ? 'post' : 'patch']('domainEmails', url, emailData).subscribe(
            (response) => {
                if(this.data.status == 'draft')
                    this.data.id = response.id;
                if(!saveAsDraft && this.data.status != 'scheduled') {
                    toastr.success('Email successfully composed');
                    // This line is the solution to a problem when the page gets redirected to an '/email-merge'
                    // from, basically, a child tab, and crashes there so all queryParams are set to email already
                    // and the change does not get detected. Don't remove unless you really know what you are doing.
                    this.es.urlService.setQueryParams('');
                    ///////////////////////////////////////////////////////////////////////////////////////////

                    //Need to clean those before we navigate out of compose email, so that ConfirmDeactivateGuard
                    //does not treat it as the navigation out by clicking on the menu link.
                    this.deactivateConfirmGuard();
                } else {
                    this.disabledSubmit = false;
                    this.isSpinnerShow = false;
                    if(!(saveAsDraft && !this.closeAfterSave))
                        this.deactivateConfirmGuard();
                }
            },
            error => {
                this.disabledSubmit = false;
                this.isSpinnerShow = false;
                this.es.api.errorHandler(error, 'Compose email failed');
            }
        );
    }

    deleteMail(id?: number, obs?: any) {
        swal(
            ConstantsService.getSwalConfig('Delete', 'Are you sure you want to delete?'),
            () => {
                if (id) {
                    this.api.remove('domainEmails', `/api/v1/mailings/${id}`).subscribe(_ => {
                        this.deactivateConfirmGuard();
                        if (obs) obs.next(true);
                    });
                } else if (this.data.id) {
                    this.api.remove('domainEmails', `/api/v1/mailings/${this.data.id}`).subscribe(_ => {
                        this.deactivateConfirmGuard();
                        if (obs) obs.next(true);
                    });
                } else {
                    this.deactivateConfirmGuard();
                }
            }
        );
    }

    toggleDropDown() {
        this.dropdown = !this.dropdown;
    }

    deactivateConfirmGuard() {
        this.data.subject = '';
        this.data.message = '';
        this.data.attachments = [];
        this.data.recipients = [];
        this.recipientFilterState = [];
        this.data.replyTo = '';
        this.data.replyToName = '';

        this.es.urlService.router.navigate(['/email-merge']);
        this.isSpinnerShow = false;
    }

    saveAndStay() {
        this.autoSave(true);
        // this.onSubmit(this.form, true, false);
    }

    saveAndClose() {
        this.closeAfterSave = true;
        this.autoSave(true);
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        // if ((file.size + this.data.getAttachmentTotalSize()) > 7000000) {
        //     toastr.warning('Maximum attachment size is 7MB.');
        //     return;
        // }
        if (Attachment.isNotAvailableType(file.name)) {
            toastr.warning('Attachment\'s type not supported.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token   = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.es.spinnerShow = true;
        this.disabledFileInput = true;
        this.disabledSubmit = true;
        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = new Attachment(file.name, file.size, res.path);
                this.data.attachments.push(attachment);
                this.disabledSubmit = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.es.spinnerShow    = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            },
            () => {
                this.es.spinnerShow    = false;
                this.disabledFileInput = false;
                this.disabledSubmit = false;
            }
        );

    }

    removeFile(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => this.data.attachments.splice(i, 1)
        );
    }

    getResidentData() {
        const result = [];
        this.recipientFilterState.forEach(item => {
            item.checkedResidents.forEach((residentId) => {
                const resident = this.es.filterRecipients.residents.find(r => r.id === residentId);
                if (!resident) { console.log('Resident not found!!!'); return; }
                if (!resident.email) { console.log('Resident without email!!!'); return; }

                const r: any = {
                    name:            resident.fullName,
                    email:           resident.email,
                    type:            resident.role,
                    buildingId:      resident.buildingId,
                    buildingName:    resident.buildingName,
                    buildingAddress: resident.buildingAddress,
                    suiteId:         resident.suiteId,
                    suiteName:       resident.suiteNumber,
                    bdId:            resident.id,
                    suiteCommonElementsFee: resident.commonElementsFee,
                };

                const homePhone     = resident.phones.find(p => p.phoneType === 'phone_home');
                const mobilePhone   = resident.phones.find(p => p.phoneType === 'phone_cell');
                const businessPhone = resident.phones.find(p => p.phoneType === 'phone_business');
                if (homePhone)     r.homePhone     = homePhone.phone;
                if (mobilePhone)   r.mobilePhone   = mobilePhone.phone;
                if (businessPhone) r.businessPhone = businessPhone.phone;

                result.push(r);
            });
        });
        return result;
    }

    getAttachmentsData(): EmailAttachment[] {
        return this.data.attachments.map(at => ({ name: at.name, fileSize: at.fileSize, path: at.path }));
    }

    applyFromField() {
        if(this.from != this.fromCopy) {
            if (this.form.controls.from.valid) {
                const user = JSON.parse(localStorage.getItem('userData'));
                if (user.userType == 'property_manager')
                    this.isChangedEmailValid(this.form.controls.from.value);
                else {
                    this.isFromEditMode = false;
                    if (this.form.controls.from.dirty)
                        toastr.warning('Changing "From" field may result in some emails being sent to spam box.');
                }
            }
        } else
            this.isFromEditMode = false;
    }

    saveRecipients(filterState) {
        this.recipientFilterState = filterState;
        $('.recipients-field').removeClass('ng-invalid');
    }

    onTypeChange(): void {
        if (this.emailMessageType == 'notice') {
            this.es.loadBuildingNotices();
        } else if (this.emailMessageType == 'template') {

        }
    }

    getUsers() {
        this.showUsersSpinner = true;
        const url = `/api/users?expand=company,phones&per-page=10000&user_type=property_manager`;
        this.api.get('oauthUrl', url).subscribe(res => {
            const body = JSON.parse(res._body);
            this.users = body.entities || [];
        }, error => this.api.errorHandler(error, 'Failed get Users'),
            () => this.showUsersSpinner = false);
    }

    changeAutocompleteValue(option) {
        const receiver = this.users.find(user => user.email == option.option.value);
        this.data.replyTo = receiver.email;
        this.data.replyToName = receiver.fullName;
    }

    /**
     * Checks if there is any building
     * with a postal code
     */
    isHasBuildingsWithPostal() {
      return this.es.buildings.filter(building => building.postalCode).length;
    }

    /**
     * Adds notice content the editor
     *
     * @param notice
     */
    onSelectNotice(notice: INpmiPublicNotice) {
        const fillForm = () => {
            this.summernote.summernote('code', this.formatNoticeContent(notice.content));
            this.data.subject = notice.title;
            this.prevNoticeContent = this.summernote.summernote('code');
            this.prevNoticeTitle = notice.title;
        };

        const isContentChanged = !this.summernote.summernote('isEmpty') && this.summernote.summernote('code') !== this.prevNoticeContent;
        const isSubjectChanged =  this.data.subject != '' && this.data.subject !== this.prevNoticeTitle;

        if(isContentChanged || isSubjectChanged) {
            swal(
              ConstantsService.getSwalConfig('Confirmation', `This action will replace email body and subject. Do you want to continue?`),
              () => fillForm()
            );

            return;
        }

        fillForm();
    }

    onSelectCorporation(corporation: ICorporation) {
        const fillForm = () => {
            this.summernote.summernote('code', this.formatNoticeContent(corporation.inviteTemplate));
            this.data.subject = corporation.inviteSubject ?  corporation.inviteSubject  : 'Invitation email';
            this.prevNoticeContent = this.summernote.summernote('code');
            this.prevNoticeTitle = this.data.subject;
        };

        const isContentChanged = !this.summernote.summernote('isEmpty') && this.summernote.summernote('code') !== this.prevNoticeContent;
        const isSubjectChanged =  this.data.subject != '' && this.data.subject !== this.prevNoticeTitle;

        if(isContentChanged || isSubjectChanged) {
            swal(
                ConstantsService.getSwalConfig('Confirmation', `This action will replace email body and subject. Do you want to continue?`),
                () => fillForm()
            );

            return;
        }

        fillForm();
    }

    /**
     * Reformat notice HTML content
     * @param htmlString
     */
    private formatNoticeContent(htmlString: string): string {
        const colorRegExp: RegExp = /(background-)?color\s?:[^;"]+/gm; // find all color and background-color styles

        htmlString = htmlString.replace(colorRegExp, '');
        htmlString = htmlString.replace(/class="rtecenter"/gm, 'style="text-align: center;"');

        return htmlString;
    }

    autoSave(leave?: boolean) {
        if (!leave) this.autoSaved = true;
        else this.autoSaved = false;
        if (this.newMessage && !this.copy) {
            this.disabledSubmit = true;
            if(this.data.id)
                this.newMessage = false;
            if (!this.data.id) this.onSubmit(this.form, true, true);
            else {
                if (this.validateFields()) {
                    const url = `/api/v1/mailings/${this.data.id}`;
                    const data = {
                        subject: this.data.subject,
                        recipients: this.getResidentData(),
                        message: this.data.message
                    };
                    this.es.api.patch('domainEmails', url, data).subscribe(
                        () => {
                            this.disabledSubmit = false;
                            if (this.closeAfterSave)
                                this.deactivateConfirmGuard();
                            toastr.success('Email has been successfully saved');
                        },
                        err => this.disabledSubmit = false
                    );
                }
            }
            this.disabledSubmit = false;
        } else if (!this.newMessage && !this.copy) {
            this.disabledSubmit = true;
            if (this.validateFields()) {
                const url = `/api/v1/mailings/${this.data.id}`;
                const data = {
                    subject: this.data.subject,
                    recipients: this.getResidentData(),
                    message: this.data.message
                };
                this.es.api.patch('domainEmails', url, data).subscribe(
                    () => {
                        this.disabledSubmit = false;
                        if (this.closeAfterSave)
                            this.deactivateConfirmGuard();
                        toastr.success('Email has been successfully saved');
                    },
                    err => this.disabledSubmit = false
                );
            }


        } else if (this.copy) {
            this.onSubmit(this.form, true, this.autoSaved);
        }
        this.initialState = Object.assign(new Email(), this.data);
    }

    isChangedEmailValid(email) {
        const url = `/v1/public/check_sender/${email}`;
        this.api.get('domainNotifications', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                if (body.status == 'Success') {
                    this.isFromEditMode = false;
                    if (this.form.controls.from.dirty)
                        toastr.warning('Changing "From" field may result in some emails being sent to spam box.');
                } else {
                    toastr.error('The entered email is not verified');
                    swal({
                        title: 'Email is not verified',
                        text: 'We will send confirmation email to your inbox. Please click Yes to proceed, or No if you want to change email.',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        closeOnConfirm: true
                    }, () => this.sendVerificationEmail(email));
                }
            },
            error => this.api.errorHandler(error, 'Failed to verify entered email.')
        );
    }

    sendVerificationEmail(email) {
        const url = '/v1/public/add_sender';
        const data = {email: email};
        this.es.api.post('domainNotifications', url, data).subscribe(
            () => toastr.success('Verification has been sent successfully'),
            (error) => this.es.api.errorHandler(error, 'Failed to send verification.')
        );
    }

    showEmailSchedulingModal() {
        let doNotSubmitForm = false;
        const recipients    = this.getResidentData();

        //if (!this.form.controls['from'].valid) { toastr.warning('Field "From" not valid.'); return; }
        if (!recipients.length) {
            $('.recipients-field').addClass('ng-invalid');
            toastr.warning('You must select recipients.');
            doNotSubmitForm = true;
        }
        if (this.isFromEditMode) {
            toastr.warning('Please enter the valid email address and confirm it before sending.');
            doNotSubmitForm = true;
        }

        if (!this.form.value.subject) {
            toastr.warning('Email Subject must be entered.');
            doNotSubmitForm = true;
        }

        if (!this.data.message) {
            toastr.warning('Message should not be blank.');
            doNotSubmitForm = true;
        }

        if (!this.data.replyTo && !this.data.replyToName && this.replyToRecipientSearch &&
            !this.replyToRecipientSearch.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
            toastr.warning('Field "Reply To" should contain the email or be empty.');

            return;
        }

        if (!doNotSubmitForm)
            this.es.isEmailSchedulingModalShow = true;
    }

    removeScheduling() {
        this.data.status = 'draft';
        this.data.scheduleDate = '';
    }

    showSaveAsDefaultInvitation() {
        return this.data.message.indexOf('[[INVITATION_LINK]]') != -1;
    }

    getCompanySettings(id) {
        if (id != 7) {
            return;
        }
        this.es.getCompanySettings(id).subscribe(
            body => {
                if (body.emailSender || body.emailSenderName) {
                    this.senderName = body.emailSenderName;
                    this.from = body.emailSender;
                }
                   // this.emailSettings.push(body);
                // if(this.from == 'notice@maxcondoclub.ca' && this.senderName == 'MaxCondoClub') {
                //     if (body.emailSender)
                //         this.from = body.emailSender ? body.emailSender : 'notice@maxcondoclub.ca';
                //     if (body.emailSenderName)
                //         this.senderName = body.emailSenderName ? body.emailSenderName : 'MaxCondoClub';
                // }
            }, error => this.es.api.errorHandler(error, 'Failed to get sender info.')
        );
    }

    getCorporationSettings() {
        this.es.getCorporationSettings().subscribe(
            body => {
                console.log(body);
                this.emailSettings = this.emailSettings.concat(body.entities)
                                                       .filter(e => e.emailSender || e.emailSenderName)
                                                       .map(e => ({
                                                           emailSender: e.emailSender ? e.emailSender : 'notice@maxcondoclub.ca',
                                                           emailSenderName: e.emailSenderName ? e.emailSenderName : 'MaxCondoClub',
                                                           draftAutoSave: e.draftAutoSave,
                                                           corporationNumberId: e.corporationNumberId
                                                       }));
                // if(this.from == 'notice@maxcondoclub.ca' && this.senderName == 'MaxCondoClub' && body.entities.length > 0) {
                //     if (body.entities[0].emailSender)
                //         this.from = body.entities[0].emailSender;
                //     if (body.entities[0].emailSenderName)
                //         this.senderName = body.entities[0].emailSenderName;
                // }

                const noAutosave = body.entities.some(s => !s.draftAutoSave);
                if(!noAutosave) {
                    this.initialState = Object.assign(new Email(), this.data);
                    this.timer = Observable.interval(60000).subscribe(_ => {
                        if (this.data.subject && this.getResidentData().length && this.data.message && this.data.status != 'scheduled') {
                            if (!lodash.isEqual(this.initialState, this.data)) {
                                this.autoSave(true);
                            }
                        }
                    });
                }
            }, error => this.es.api.errorHandler(error, 'Failed to get sender info.')
        );
    }

    onEmailSettingsChange(event) {
        // this.from = event.value.emailSender;
        // this.senderName = event.value.emailSenderName;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/compose-email/compose-email.component.ts